export const VIEWPORT_RADIUS = 8;
export const TICK_INTERVAL = 2500;

export const COLORS = {
    viewportFill: "rgba(136, 206, 252, 0.4)",
    viewportStroke: "#0D99FF",
    itemFill: "rgba(184, 186, 191, 0.35)",
};
export const MIN_RECT_SIZE = 0.5;
export const MIN_VIEWPORT_SIDE = 2;

export const LOCK_MAX_DPR = 2;

export const MINIMAP_WIDTH = 300;
export const MINIMAP_HEIGHT = 180;
